import type { AuthorizedResource } from '@/services/bff/permission.api';
import { MEETING_ROOM_PERMISSION_RESOURCE } from './definitions';

export type AuthorizedResourceAccessMap = Record<string, boolean>;

export const TENANT_ADMIN_ACCESS_KEY = '__tenant_admin__';

export function buildAuthorizedResourceAccessMap(
  resources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  return resources.reduce<AuthorizedResourceAccessMap>((access, resource) => {
    if (!resource?.code || resource.effect !== 'ALLOW') {
      return access;
    }

    access[resource.code] = true;
    for (const action of resource.actions || []) {
      const name = typeof action === 'string' ? action : action?.name;
      if (name) {
        access[`${resource.code}:${name}`] = true;
      }
    }
    return access;
  }, {});
}

export const permissionKey = (resource: string, action?: string) =>
  action ? `${resource}:${action}` : resource;

export const grantTenantAdminAccess = (
  access: AuthorizedResourceAccessMap,
): AuthorizedResourceAccessMap => {
  const elevatedAccess: AuthorizedResourceAccessMap = {
    ...access,
    [TENANT_ADMIN_ACCESS_KEY]: true,
  };

  for (const resource of Object.values(MEETING_ROOM_PERMISSION_RESOURCE)) {
    elevatedAccess[resource] = true;
  }

  return elevatedAccess;
};
